<section *ngIf="auth.user$ | async as user">

  <div class="token">
    <span> Access token: <pre
      class="rounded"
    ><code class="json" [highlight]="token || ''"></code></pre></span>
    <button mat-button (click)="getToken()">Get</button>
  </div>

  <div class="row" *ngIf="profileJson">
    <pre
      class="rounded"
    ><code class="json" [highlight]="profileJson"></code></pre>
  </div>
</section>
